module.exports = __webpack_public_path__ + "static/media/take.cf788d6a.svg";